import React, { FC } from 'react'
import { ValidMaterialPricingDetailFragment } from '@src/fragments/ProductPricing.generated'
import ShipsTodayIcon from '@src/icons/ShipsTodayIcon'
import { FormattedMessage } from 'react-intl'
import messages from '@src/utils/messages'
import { makeStyles } from 'tss-react/mui'
import FreeFreightIcon from '@src/icons/FreeFreightIcon'
import { Box } from '@mui/material'

const useStyles = makeStyles()((theme) => ({
  shippingMessage: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(14),
    '& > *': {
      marginRight: theme.spacing(2),
    },
  },
}))

interface Props {
  material: ValidMaterialPricingDetailFragment
}

const ShippingMessages: FC<Props> = ({ material }) => {
  const { classes } = useStyles()

  return (
    <>
      {material.shipsToday && (
        <Box mb={6} className={classes.shippingMessage}>
          <ShipsTodayIcon />
          <FormattedMessage {...messages.SHIPS_TODAY} />
        </Box>
      )}

      {material.freeFreight && (
        <Box mb={6} className={classes.shippingMessage}>
          <FreeFreightIcon color="secondary" />
          <FormattedMessage {...messages.FREE_FREIGHT} />
        </Box>
      )}
    </>
  )
}

export default ShippingMessages
